export default "__VITE_ASSET__BKBOWAhk__"